import React, { useEffect, useState, useRef } from 'react';
import { formatDate } from '../../common';
import { MessageBubble, StyledMessageContent, MessageTimestamp } from '../../styles/UserWorkspacePageStyles';

const TypingMessage = ({ text, isUser, createdAt, children }) => {
  const [displayedText, setDisplayedText] = useState('');
  const indexRef = useRef(0);

  useEffect(() => {
    let currentText = '';
    indexRef.current = 0;
    setDisplayedText('');
    const interval = setInterval(() => {
      if (indexRef.current < text.length) {
        currentText += text[indexRef.current];
        setDisplayedText(currentText);
        indexRef.current += 1;
      } else {
        clearInterval(interval);
      }
    }, 20);

    return () => clearInterval(interval);
  }, [text]);

  return (
    <MessageBubble isUser={isUser}>
      {children || (
        <StyledMessageContent>
          <div>
            {displayedText}
          </div>
        </StyledMessageContent>
      )}
      <MessageTimestamp>{formatDate(createdAt || new Date())}</MessageTimestamp>
    </MessageBubble>
  );
};

export default TypingMessage;
